import React, { useState, useReducer, useEffect, useRef } from "react";

// Components imports
import ProcessorsContainer from "../../components/Processors/ProcessorsContainer";
import CategoriesProcessorsNavigation from "../../components/common/CategoriesProcessorsNavigation";

// Scss imports
import css from "./Processors.module.scss";

// redux
import { useSelector, useDispatch } from "react-redux";
import { getFruits } from "../../redux/actions/getFruitsAction";

import {
  getProcessors,
  addProcessor,
  updateProcessor,
  getActiveProcessors,
  resetStore,
  manuallyTrigerMessage,
} from "../../redux/actions/processorsActions";

import { logout } from "../../redux/actions/loginAction";

import { useHistory } from "react-router-dom";

interface ProcessorsProps {}

const Processors: React.FC<ProcessorsProps> = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const addProcessorStatus = useSelector(
    (state: any) => state.allProcessors.addProcessor
  );

  // get all processors error
  const getActiveProcessorError = useSelector(
    (state: any) => state.allProcessors.processorsActiveError
  );

  // Setting up state for input values, using use reducer hook
  const [userInput, setUserInput] = useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      firstName: "",
      lastName: "",
      nationalId: "",
      phone: "",
    }
  );

  // Setting up form
  const [form, setForm] = useState({
    name: userInput.firstName + " " + userInput.lastName,
    nationalId: userInput.nationalId,
    phoneNumber: userInput.phone,
  });

  // State for hanling state of show all / show just active processors
  const [showAllProcessors, setShowAllProcessors] = useState(false);

  const [parent, setParent]: any = useState();

  // On input change set input name and value to text that user added
  const handleChange = (e: any) => {
    const name = e.target.name;
    const newValue = e.target.value;
    setUserInput({ [name]: newValue });
  };

  const processors = useSelector(
    (state: any) => state.allProcessors.processors
  );

  const activeProcessors = useSelector(
    (state: any) => state.allProcessors.processorsActive
  );

  const [renderedNewProcessorItem, setRenderedNewProcessorItem] =
    useState(false);

  const fruits = useSelector((state: any) => state.allFruits);

  // Clean object before update function
  const clean = (obj) => {
    for (var propName in obj) {
      if (
        obj[propName] === "" ||
        //obj[propName] === 0 ||
        obj[propName] === null ||
        obj[propName] === undefined
      ) {
        delete obj[propName];
      }
    }
    return obj;
  };

  // Create processor function
  const createProcessor = (e) => {
    setParent(e.target.parentNode);
    dispatch(
      addProcessor(
        {
          firstName: userInput.firstName,
          lastName: userInput.lastName,
          nationalId: userInput.nationalId,
          phoneNumber: userInput.phone,
        },
        history
      )
    );

    if (addProcessorStatus === "fail") {
      setTimeout(() => {
        dispatch(manuallyTrigerMessage(""));
      }, 3000);
    }
    // If add processor status === 'sucess' remove add processor box
  };
  // Edit processor function
  const editProcessor = (e) => {
    let divArray: any = [];
    const inputValues: any = [];
    const buttonClicked = e.target;
    const clickedContainer: HTMLElement = buttonClicked.parentNode;
    const formElement: Element[] = Array.from(clickedContainer.children);
    divArray = [formElement[0], formElement[1], formElement[2], formElement[3]];

    divArray.forEach((divElement) => {
      const input: any = divElement.children[2].children[0];
      inputValues.push(input.value);
    });

    const id: any = clickedContainer.dataset.id;

    dispatch(
      updateProcessor(
        clean({
          firstName: inputValues[0],
          lastName: inputValues[1],
          nationalId: inputValues[2],
          phoneNumber: inputValues[3],
        }),
        id
      )
    );

    if (addProcessorStatus === "fail") {
      setTimeout(() => {
        dispatch(manuallyTrigerMessage(""));
      }, 3000);
    }
  };

  useEffect(() => {
    dispatch(resetStore());
    setRenderedNewProcessorItem(false);
  }, [dispatch]);

  useEffect(() => {
    if (addProcessorStatus === "fail") {
      setRenderedNewProcessorItem(true);
      setTimeout(() => {
        dispatch(manuallyTrigerMessage(""));
      }, 3000);
    }
    if (addProcessorStatus === "sucess") {
      setRenderedNewProcessorItem(false);
      //const el: any = document.getElementById("addItem");
      if (parent) {
        parent.parentNode.parentNode.remove();
        userInput.firstName = "";
        userInput.lastName = "";
        userInput.nationalId = "";
        userInput.phone = "";
      }
      dispatch(getActiveProcessors());
      dispatch(getProcessors());
    }
  }, [addProcessorStatus, parent]);

  useEffect(() => {
    setRenderedNewProcessorItem(false);
  }, []);

  useEffect(() => {
    dispatch(getActiveProcessors());
    // req dispatch(getProcessors());
  }, [dispatch]);

  return (
    <div className={css.container}>
      {/*<button onClick={() => dispatch(getProcessors([{ anna: "" }]))}>
        {fruits[0].genus}
			</button>*/}
      {/* Buttons row */}
      <h1>Унесите обрађиваче</h1>
      <p className={css.errorText}>{getActiveProcessorError}</p>
      <CategoriesProcessorsNavigation
        processorButtonClickHandler={() =>
          setShowAllProcessors((prevState) => !prevState)
        }
        showAllText={
          showAllProcessors ? "Активни обрађивачи" : "Сви обрађивачи"
        }
      />
      {showAllProcessors ? (
        <ProcessorsContainer
          processors={processors.data}
          createProcessor={createProcessor}
          editProcessor={editProcessor}
          renderedNewProcessorItem={renderedNewProcessorItem}
          setRenderedNewProcessorItem={setRenderedNewProcessorItem}
          firstName={userInput.firstName}
          lastName={userInput.lastName}
          nationalId={userInput.nationalId}
          phone={userInput.phone}
          handleChange={handleChange}
          addProcessorStatus={addProcessorStatus}
          showAllProcessors={showAllProcessors}
        />
      ) : (
        <ProcessorsContainer
          processors={activeProcessors.data}
          createProcessor={createProcessor}
          editProcessor={editProcessor}
          renderedNewProcessorItem={renderedNewProcessorItem}
          setRenderedNewProcessorItem={setRenderedNewProcessorItem}
          firstName={userInput.firstName}
          lastName={userInput.lastName}
          nationalId={userInput.nationalId}
          phone={userInput.phone}
          handleChange={handleChange}
          addProcessorStatus={addProcessorStatus}
          showAllProcessors={showAllProcessors}
        />
      )}
    </div>
  );
};

export default Processors;
